module.exports = __webpack_public_path__ + "static/media/rollerball.b8996c77.png";